import classes from './RoomHI.module.css';
import logo from "../../../../store/Hi_horizontal.png"
import {useEffect, useState} from "react";
import { path, assetsBaseUrl } from "../../../../routes";
import axios from "axios";

const RoomHI = (props) => {
    const [actTime, setactTime] = useState("undefined");
    const [actDate, setactDate] = useState("undefined");
    const [roomName, setroomName] = useState();
    const [needUpdate, setneedUpdate] = useState();
    const [def, setDefa] = useState(props.default);
    const [logoOrg, setLogoOrg] = useState(props.logoOrg);
//props.object
    const [loadedSlides, setLoadedSlides] = useState(props.object.object)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentIndexdef, setCurrentIndexdef] = useState(0);
    
    // Synchronizace loadedSlides s props když se změní
    useEffect(() => {
        if (props.object?.object && Array.isArray(props.object.object)) {
            setLoadedSlides(props.object.object);
        }
    }, [props.object?.object]);

    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }
    // const actTime = `${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
    //const actDate = `${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`;
    useEffect(() => {

        const norm = (p) => (p || '').replace(/\\/g, '/');
        const getDefaultSlides = async () => {
            let tmpA = [];
            let response = await axios.get(`${path}/getDefaultScreen`);
            for (let i = 0; i < (response.data?.length || 0); i++) {
                tmpA.push(assetsBaseUrl + norm(response.data[i].path));
            }
            setDefa([...tmpA]);
        }



        console.log(loadedSlides)
        const getDevice = async () => {
            let response = await axios.get(`${path}/getRoomDetail/${props.object.id}`);
        }
        const getRecords = async () => {
            //console.warn(def)
            await getDefaultSlides()
            try {
                let response
                if (props.object.idTS == 11) response = await axios.get(`${path}/getMeeting1Query?id=${props.object.id}&day=${encodeURIComponent(getTime())}`);
                if (props.object.idTS == 12) response = await axios.get(`${path}/getMeeting2/${encodeURIComponent(getTime())}`);
                if (props.object.idTS == 13) response = await axios.get(`${path}/getMeeting3/${encodeURIComponent(getTime())}`);
                if (props.object.idTS == 12 || props.object.idTS == 13) {
                    if (response.data.length != loadedSlides.length) {
                       window.location.reload();
                    }

                }
                if (response.data.length > 0) {
                    let p = []

                    setLoadedSlides(response.data)
                    setCurrentIndex(0)
                } else {
                    setLoadedSlides([])
                    setCurrentIndex(0)

                }

            } catch (error) {

            }
        }
        // Funkce, která se spustí každou minutu
        const intervalId2 = loadedSlides.length > 0 ? setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % loadedSlides.length);
        }, 10000) : null;
        const intervalId4 = setInterval(() => {
            setCurrentIndexdef((prevIndex) => (prevIndex + 1) % def.length);
        }, 10000);
        const updateMinute = () => {
            let dt = new Date
            //console.log(dt)
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`)
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`)
        };

        // Nastavení intervalu pro reload meeting dat (dřív bylo 60 s)
        const intervalId = setInterval(updateMinute, 1000);
        const intervalId3 = setInterval(getRecords, 20 * 1000);
        
        // Okamžité načtení dat při prvním renderu
        updateMinute();
        getRecords();

        // Cleanup funkce, která se spustí při unmountu komponenty
        return () => {
            clearInterval(intervalId)
            if (intervalId2) clearInterval(intervalId2);
            clearInterval(intervalId3);
            clearInterval(intervalId4);
        };
    }, [props.object?.id, props.object?.idTS, def.length]);
    useEffect(() => {
        const resetVal = async () =>{
            let rs
            if (props.object.idTS == 11) rs = await axios.post(`${path}/updateReset/${props.object.id}`)
            if (props.object.idTS == 12) rs = await axios.post(`${path}/updateReset/30`)
            if (props.object.idTS == 13) rs = await axios.post(`${path}/updateReset/31`)
        }

        const getReset = async () =>{
            try {
                let response
                if (props.object.idTS == 11) response = await axios.get(`${path}/getReset/${props.object.id}`);
                if (props.object.idTS == 12) response = await axios.get(`${path}/getReset/30`);
                if (props.object.idTS == 13) response = await axios.get(`${path}/getReset/31`);
                console.log(response.data[0].needUpdate);
                if (response.data[0].needUpdate === 1)
                {
                    // console.log("update")
                    resetVal()
                    console.log(`FE_refresh needed: ${response.data[0].needUpdate === 1? "YES":"NO"}`)
                    window.location.reload();

                }
                else {
                    //setneedUpdate(0)
                    console.log(`FE_refresh needed: ${response.data[0].needUpdate === 1? "YES":"NO"}`)
                }
            }
            catch (error){

            }
        }
        const intervalId5 = setInterval(getReset, 60 * 2 * 1000);
        return () => {
            clearInterval(intervalId5);
        };
    }, []);
    const normPath = (p) => (p || '').replace(/\\/g, '/');
    const slide = loadedSlides[currentIndex];
    const meetingTitle = slide?.txt || slide?.description || '';
    const imgSrc = slide?.path ? `${assetsBaseUrl}${normPath(slide.path)}` : '';
    // Preferovat název místnosti, pokud není k dispozici, použít název meetingu
    const displayTitle = (props.roomName && props.roomName.trim()) 
        ? props.roomName.trim() 
        : (meetingTitle && meetingTitle.trim() ? meetingTitle.trim() : 'Meeting Room');
    const hasMeeting = loadedSlides.length > 0;
    const headerEl = <div className={classes.header}>
        <div className={classes.time}>
            <div className={classes.timeA}>{actTime}</div>
            <div className={classes.lineT}></div>
            <div className={classes.timeB}>{actDate}</div>
        </div>
        <div className={classes.name}>
            {displayTitle}
        </div>
    </div>
    const bodyEl = <div className={classes.body}>
        {loadedSlides.length != 0 && imgSrc &&
            <img src={imgSrc} alt={meetingTitle || 'Meeting'} />
        }
        {loadedSlides.length == 0 && <img src={def[currentIndexdef]} alt={"logo"} className={classes.def}/>
        }
    </div>
    const footerEl = <div className={classes.footer}>
        <div className={`${classes.line} ${props.object.idTS === 13 && classes.lineSmall}`}>
            <div className={classes.lineL}></div>
        </div>
        <div className={classes.logo}>
            <img src={logo} alt={"logo"}/>
        </div>
    </div>
    return <div className={classes.main}>
        {props.object.idTS == 12 || loadedSlides.length != 0 ?headerEl:""}
        {props.object.idTS == 12 || loadedSlides.length != 0 ? bodyEl:""}
        {props.object.idTS == 12 || loadedSlides.length != 0 ? footerEl:""}
        {loadedSlides.length == 0 && props.object.idTS != 12 ?
            <img src={def[currentIndexdef]} alt={"logo"} className={classes.def}/> : ""
        }

    </div>
}
export default RoomHI